// PhonicsLt10.js
// 包装组件：Letter Teams L10
// 路由：/phonics/lt10
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt10 } from './phonics/phonics_data_lt10';

function PhonicsLt10() {
  return <PhonicsLt letterData={letterDataLt10} />;
}

export default PhonicsLt10;
